// extracted by mini-css-extract-plugin
export default {"root":"pending-approval-badge_root__i6Qnr","note":"pending-approval-badge_note__7VKNT","icon":"pending-approval-badge_icon__aqb87"};